import { memo } from "react";
import styled from "styled-components";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";

const StyledPopup = styled(Popup)`
  &-content {
    width: auto;
    overflow: hidden;
  }
`;

const StyledContainer = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
`;

const StyledHeader = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const PopupWindow = (props: {
  showModal: boolean;
  handleModalClose: any;
  childComponent: JSX.Element;
}): JSX.Element => {
  const { showModal, handleModalClose, childComponent } = props;

  return (
    <StyledPopup
      open={showModal}
      position="right center"
      onClose={handleModalClose}
      modal={true}
    >
      <StyledHeader>
        <button onClick={handleModalClose}>X</button>
      </StyledHeader>
      <StyledContainer>{childComponent}</StyledContainer>
    </StyledPopup>
  );
};

export default memo(PopupWindow);
